import React from "react";
import NavBar from "../components/NavBar";
import HeroImage from "../components/HeroImage";
import Timeline from "../components/TimelineContent";
import ProjectCard from "../components/Project";
import Footer from "../components/Footer";
import SkillsContent from "../components/SkillsContent";

const Home = () => {
  return (
    <div>
      <NavBar />
      <HeroImage />
      {/* <SkillsContent /> */}
      {/* <ProjectCard /> */}
      {/* <Timeline /> */}
      {/* <Footer /> */}
    </div>
  );
};

export default Home;
